import React from "react";
import styled from "styled-components/macro";
import BottomServiceBanner from "../../../components/ServiceBanner/BottomServiceBanner";
import TopServiceBanner from "../../../components/ServiceBanner/TopServiceBanner";
import banner from "../../../assets/images/MedInfo/pngtree-minimalistic-technology-medical-medical-banner-poster-background-image_181032.jpg";
import { BiChevronsRight } from "react-icons/bi";
import img from "../../../assets/images/MedInfo/ic_drugs-512.webp"
import BottomBanner from "../../../components/ServiceBanner/BottomBanner";


const MedInfo = () => {

  return (
    <Container>
      <TopServiceBanner title=" Med Info" banner={banner} />
      <Inner>
        <Title>Med Information Center</Title>
        <SubTitle>
          The Lincourt Med Information Center provides accurate, unbiased and
          evidence-based drug information to health care professionals and
          patients within the state of Florida.
        </SubTitle>
        <Middle>
          <MiddleInner>
            <MiddleInnerLeft>
              <MiddleTextLeft>Services</MiddleTextLeft>
              <MiddleSubTitle>
                The Med Information Center responds to requests regarding:
              </MiddleSubTitle>
              <Ul>
                <Li>
                  <BiChevronsRight />
                  Therapeutic use of drugs (on-label or off-label)
                </Li>
                <Li>
                  <BiChevronsRight />
                  Adverse drug reactions
                </Li>
                <Li>
                  <BiChevronsRight />
                  Drug-drug and drug-herbal interactions
                </Li>
                <Li>
                  <BiChevronsRight />
                  IV compatibility
                </Li>
                <Li>
                  <BiChevronsRight />
                  Availability of new products
                </Li>
                <Li>
                  <BiChevronsRight />
                  Herbal products, dietary supplements and over-the-counter
                  products
                </Li>
                <Li>
                  <BiChevronsRight />
                  Pregnancy and lactation compatibility
                </Li>
                <Li>
                  <BiChevronsRight />
                  Drug dosing and administration
                </Li>
              </Ul>
            </MiddleInnerLeft>
            <MiddleInnerRight>
            <Img src={img} alt="ALF" />
          </MiddleInnerRight>
          </MiddleInner>
        </Middle>

        <Title>Education</Title>
        <SubTitle>
          The Med Information Center also serves as an advanced pharmacy
          practice experience (APPE) rotation site to educate students in
          retrieval of drug information using available resources, literature
          evaluation, and communicating drug information to patients and health
          care professionals in verbal and written form. In addition, our
          students participate in research that investigates the accuracy and
          completeness of drug information resources.
        </SubTitle>
      </Inner>
      <BottomServiceBanner />
      <BottomBanner />

    </Container>
  );
};

export default MedInfo;

const Container = styled.div``;
const Inner = styled.div``;

const SubTitle = styled.h2`
  font-size: 23px;
  font-weight: normal;
  line-height: normal;
  text-align: center;
  padding: 0rem 3rem 3rem 3rem;
  margin-top: 2rem;
  opacity: 0.6;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const Middle = styled.div`
  background: var(--color-blue);
  clip-path: polygon(50% 10%, 100% 0, 100% 100%, 50% 90%, 0 100%, 0 0);
  padding-bottom: 10rem;
  padding-top: 1rem;
`;

const MiddleSubTitle = styled.h2`
  font-size: 20px;
  font-weight: normal;
  line-height: normal;
  color: white;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const MiddleInner = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin-top: 10rem;

  @media (max-width: 1180px) {
    flex-direction: column;
    gap: 1rem;
    margin-top: 2rem;
  }
`;

const MiddleInnerLeft = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media (max-width: 46px) {
    margin-bottom: 2rem;
  }
`;
const MiddleInnerRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MiddleTextLeft = styled.h1`
  font-size: 30px;
  line-height: 1.1;
  color: white;
  margin-bottom: 1rem;
  text-align: center;

  @media (max-width: 600px) {
    font-size: 20px;
    margin-bottom: 2rem;
  }
`;

const Ul = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-top: 1rem;

  @media (max-width: 380px) {
    padding: 2rem 0.5rem 2rem 1.5rem;
  }
`;
const Li = styled.li`
  font-size: 1.2rem;
  letter-spacing: 1px;
  list-style: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;

  @media (max-width: 600px) {
    font-size: 1.1rem;
    letter-spacing: normal;
    padding: 0rem 0.5rem 0rem 1.5rem;
  }

  @media (max-width: 460px) {
    font-size: 0.9rem;
  }
`;
const Img = styled.img`
  width: 100%;
  height: 100%;

  @media (max-width: 1180px) {
    width: 45%;
    height: 45%;
    margin-top: 1rem;
  }
`;

const Title = styled.h1`
  font-size: 40px;
  line-height: 1.1;
  color: var(--color-blue);
  text-align: center;
  margin-top: 3rem;

  &:hover {
    color: var(--color-red);
  }

  @media (max-width: 600px) {
    font-size: 30px;
  }
`;
